import { render, staticRenderFns } from "./MassSendCustomer.vue?vue&type=template&id=161ed000&scoped=true&"
import script from "./MassSendCustomer.vue?vue&type=script&lang=js&"
export * from "./MassSendCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161ed000",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('161ed000')) {
      api.createRecord('161ed000', component.options)
    } else {
      api.reload('161ed000', component.options)
    }
    module.hot.accept("./MassSendCustomer.vue?vue&type=template&id=161ed000&scoped=true&", function () {
      api.rerender('161ed000', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/operate/MassSendCust/MassSendCustomer.vue"
export default component.exports